import { render, staticRenderFns } from "./NutritionRow.vue?vue&type=template&id=073683b2&scoped=true&"
import script from "./NutritionRow.vue?vue&type=script&lang=ts&"
export * from "./NutritionRow.vue?vue&type=script&lang=ts&"
import style0 from "./NutritionRow.vue?vue&type=style&index=0&id=073683b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073683b2",
  null
  
)

export default component.exports